import { memo } from 'react';
import { Link } from './styles';

const SkipLink: React.FC = () => <Link href="#main-content">Pular para o conteúdo</Link>;

export default memo(SkipLink);
